module.exports = __webpack_public_path__ + "img/businessplan.d25ea475.png";